import { TRAVEL_INSURANCE_FORM_SET_VALUE } from '../../../actions/travelKe/quote';

export const isTravelKeAction = (action) => action.type.startsWith(TRAVEL_INSURANCE_FORM_SET_VALUE);
